import { useNavigate } from 'react-router-dom'
import { SectionAction, SectionCard, Skeleton } from '@lighthouse/design'
import { IconRadar } from '@tabler/icons-react'
import { HealthLineRow } from '../health/HealthLineRow'
import { useSignalSummary } from '../../hooks/useSignals'
import { detectorLine } from './signalFormat'

/**
 * The Health page's "Signal detector" row: whether the thing that raises signals is running.
 *
 * One row, read from the signal summary — the same key the Overview tiles and the rail badge poll, so it adds no
 * request. Only a fresh evaluation is green and only a stopped detector is red (it is the monitoring that has
 * failed); an unprovisioned store, a detector that never ran and a failed request are dashes, since none of them
 * is an answer about the detector (signalFormat.detectorLine).
 *
 * Links in-app through navigate, never by href, as the rest of the Health page does.
 */
export function SignalDetectorSection() {
  const navigate = useNavigate()
  const line = detectorLine(useSignalSummary())
  const open = () => navigate('/signals')

  return (
    <SectionCard
      title="Signal detector"
      subtitle="Automaton's detector raises and clears signals from what the rows on this page already measure. It is one more thing to watch, not a verdict on them."
      action={<SectionAction onClick={open}>Open the Signal Inbox →</SectionAction>}
      flush
    >
      <div data-health-section="signals">
        {line.kind === 'loading' ? (
          <div style={{ padding: '6px 16px' }}>
            <Skeleton height={18} />
          </div>
        ) : (
          <HealthLineRow
            rowKey="signal-detector"
            icon={<IconRadar size={15} />}
            name="Signal detector"
            detail={line.detail}
            status={line.status}
            statusLabel={line.label}
            onOpen={open}
          />
        )}
      </div>
    </SectionCard>
  )
}
